import type { ComponentPropsWithRef } from "react";
import { cn } from "@/lib/utils";

export type SpinnerProps = Omit<ComponentPropsWithRef<"div">, "children"> & {
  loadingLabel: string;
  size?: "sm" | "md" | "lg";
  variant?: "default" | "inverse" | "muted" | "onDark";
};

const sizeClasses = {
  sm: "w-4 h-4 border-2",
  md: "w-6 h-6 border-2",
  lg: "w-7 h-7 border-[3px]",
};

const variantClasses = {
  default: "border-primary-500/20 border-t-primary-600",
  inverse: "border-white/30 border-t-white",
  muted: "border-surface-200 border-t-surface-400",
  onDark: "border-surface-600 border-t-surface-400",
};

export function Spinner({
  loadingLabel,
  size = "md",
  variant = "default",
  className,
  ...rest
}: SpinnerProps) {
  return (
    <div
      className={cn(
        "animate-spin rounded-full",
        variantClasses[variant],
        sizeClasses[size],
        className,
      )}
      role="status"
      aria-label={loadingLabel}
      {...rest}
    >
      <span className="sr-only">{loadingLabel}</span>
    </div>
  );
}
